export default {
  getTranslated: (state) => (locale, key, subobject) => {
    if (!subobject) {
      var selections = state.selections;
    } else {
      var selections = state[subobject].selection;
    }

    var selectionItemToBeGet = 'selectionValueEnglish';
    var translatedOptionsList = [];
    switch (locale.toLowerCase()) {
      case 'en_us':
        selectionItemToBeGet = 'selectionValueEnglish';
        break;
      case 'zh_hk':
        selectionItemToBeGet = 'selectionValueZhHk';
        break;
      case 'zh_cn':
        selectionItemToBeGet = 'selectionValueZhCn';
        break;
    }

    if (!selections) {
      return [];
    }

    let result = selections.filter((item) => {
      return key === item.name;
    }).map((item) => {
      return {
        name: item.name,
        options: item.options.map((item) => {
          return {
            value: item.selectionKey,
            text: item[selectionItemToBeGet]
          }
        })
      }
    });
    return result.length > 0 ? result[0].options : [];
  },

  getServiceRequestTranslated: (state, getters) => (locale, column, key) => {
    let result = getters.getTranslated(locale, column);

    result = result.filter((selection) => {
      return selection.value === key;
    });

    if (result.length > 0) {
      return result[0].text;
    }

    return 'N/A';
  },

  getTranslatedArray: (state, getters) => (locale, key) => {
    let result = state.selectedType.selection;

    if (result.length > 0) {
      return result;
    }

    return [];
  },

  getTranslatedString: (state, getters) => (locale, column, target, fieldType, filters) => {
    let selection = getters.getTranslated(locale, column, 'selectedType');

    let result = selection.filter((item) => {
      return item.value === target;
    });

    if (result.length > 0) return result[0].text

    switch (fieldType) {
      case 'datetime':
        return filters.date(target);
        return target
      default:
        return target;
    }
  },

  isValueModified: (state) => (column, value) => {
    return state.selectedType.data[column] !== value;
  }
}



// WEBPACK FOOTER //
// ./src/Osm/ServiceRequest/store/getters.js